<template>
  <div class="login-page">
    <v-container>
      <v-row style="min-height: 90vh" justify="center" align="center">
        <v-card
          width="431"
          height="509"
          style="border: 1px solid #000000; border-radius: 15px;"
          :class="$vuetify.breakpoint.xs ? 'rounded-0' : 'rounded-lg'"
        >
          <v-card-text style="width: auto">
            <div align="center">
              <v-img class="mt-4"
                src="@/assets/Langham-UI.png"
                width="277.5"
                height="97.57"
              />
              <v-img class="mt-4"
                src="@/assets/Langham-text2.png"
                width="177.49"
                height="54.37"
              />
            </div>
            <br />
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  placeholder="Username"
                  name="login"
                  type="text"
                  outlined
                  style="font-size: 20px; color: #231F20"
                  class="login-rounded-field"
                  v-model="username"
                  @keyup.enter="Login"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="12">
                <v-text-field
                  outlined
                  class="login-rounded-field"
                  placeholder="Password"
                  :type="ShowPassword ? 'text' : 'password'"
                  id="password"
                  style="font-size: 20px; color: #231F20"
                  @keyup.enter="Login"
                  v-model="password"
                >
                  <template v-slot:append>
                    <img
                      v-show="ShowPassword"
                      src="@/assets/icons/eye.png"
                      width="20"
                      height="20"
                      class="password-eye-icon"
                      @mousedown.prevent
                      @click.stop="ShowPassword = false"
                    />
                    <img
                      v-show="!ShowPassword"
                      src="@/assets/icons/eye-slash.png"
                      width="20"
                      height="20"
                      class="password-eye-icon"
                      @mousedown.prevent
                      @click.stop="ShowPassword = true"
                    />
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="12">
                <v-btn
                  block
                  color="#231F20"
                  style="color: white; font-size: 16px;"
                  @click="Login()"
                  class="login-rounded-button"
                  width="387"
                  height="45"
                  >Sign In</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>

    <v-dialog v-model="RegisterDialog" persistent width="900">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseRegisterDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <div align="left">
                <v-img
                  width="290"
                  height="auto"
                  src="@/assets/vone-logo.png"
                ></v-img>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h1 style="color: black">Register | ลงทะเบียน</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                placeholder="Username"
                label="Username"
                type="text"
                outlined
                v-model="Username_Register"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                block
                x-large
                color="#1D2939"
                style="color: white"
                @click="CheckDuplicateUsername(Username_Register)"
                class="rounded-lg"
                >ตรวจสอบ Username</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                placeholder="Password"
                label="Password"           
                :type="ShowPassword ? 'text' : 'password'"
                id="Password_Register"
                v-model="Password_Register"
              >
                <template v-slot:append>
                  <img
                    v-show="ShowPassword"
                    src="@/assets/icons/eye.png"
                    width="20"
                    height="20"
                    class="password-eye-icon"
                    @mousedown.prevent
                    @click.stop="ShowPassword = false"
                  />
                  <img
                    v-show="!ShowPassword"
                    src="@/assets/icons/eye-slash.png"
                    width="20"
                    height="20"
                    class="password-eye-icon"
                    @mousedown.prevent
                    @click.stop="ShowPassword = true"
                  />
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                placeholder="Re Password"
                label="Re Password"
                :type="ShowRePassword ? 'text' : 'password'"
                id="RePassword_Register"
                v-model="RePassword_Register"
              >
                <template v-slot:append>
                  <img
                    v-show="ShowRePassword"
                    src="@/assets/icons/eye.png"
                    width="20"
                    height="20"
                    class="password-eye-icon"
                    @mousedown.prevent
                    @click.stop="ShowRePassword = false"
                  />
                  <img
                    v-show="!ShowRePassword"
                    src="@/assets/icons/eye-slash.png"
                    width="20"
                    height="20"
                    class="password-eye-icon"
                    @mousedown.prevent
                    @click.stop="ShowRePassword = true"
                  />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                placeholder="First Name"
                label="First Name"
                type="text"
                outlined
                v-model="Firstname_Register"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                placeholder="Last Name"
                label="Last Name"
                type="text"
                outlined
                v-model="Lastname_Register"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                placeholder="Email"
                label="Email"
                type="email"
                outlined
                v-model="Email_Register"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                placeholder="Telephone"
                label="Telephone"
                type="number"
                outlined
                v-model="Telephone_Register"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <v-btn
                width="250"
                color="green"
                class="rounded-lg white--text"
                x-large
                @click="Register()"
                >Submit</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
// import LoadingComponent from "@/components/Loading";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "Login",
  components: {
    // LoadingComponent,
  },
  data() {
    return {
      model: "tab-1",
      url: enurl.apiUrl,
      LoadingDialog: false,

      flagPassword: false,
      username: "",
      password: "",

      RegisterDialog: false,
      ShowPassword: false,
      ShowRePassword: false,

      //Register
      Username_Register: "",
      Password_Register: "",
      RePassword_Register: "",
      Firstname_Register: "",
      Lastname_Register: "",
      Telephone_Register: "",
      Email_Register: "",
    };
  },

  mounted() {
    this.tokenInterval = setInterval(() => {
      const token = this.$cookies.get("Token");
      if (token) {
        this.$store.dispatch("CheckToken", { token });
      }
    }, 10 * 1000);
  },

  beforeDestroy() {
    if (this.tokenInterval) clearInterval(this.tokenInterval);
  },

  methods: {
    Login() {
      let self = this;
      if (!self.username || !self.password) {
        Swal.fire("กรุณากรอกข้อมูลให้ครบถ้วน !");
      } else {
        self.LoadingDialog = true;
        let temp = {
          Username: self.username,
          Password: self.password,
        };
        self.$store
          .dispatch("LoginUser", temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.$router.push("/ProjectSite");
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              width: 500,
              text: error.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    Register() {
      let self = this;
      if (
        !self.Username_Register ||
        !self.Password_Register ||
        !self.RePassword_Register ||
        !self.Firstname_Register ||
        !self.Lastname_Register ||
        (!self.Email_Register && !self.Telephone_Register)
      ) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          Username: self.Username_Register,
          Password: self.Password_Register,
          RePassword: self.RePassword_Register,
          Firstname: self.Firstname_Register,
          Lastname: self.Lastname_Register,
          Email: self.Email_Register,
          Telephone: self.Telephone_Register,
        };
        axios
          .post(`${self.url}Login/Register`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Register Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.CloseRegisterDialog();
            } else if (response.data.status == 1) {
              Swal.fire({
                icon: "warning",
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          })
          .catch(function (error) {
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

            Swal.fire({
              icon: "warning",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    CheckDuplicateUsername(username) {
      let self = this;
      if (!username) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          Username: username,
        };
        axios
          .post(`${self.url}Login/CheckDuplicateUsername`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.LoadingDialog = false;
              if (response.data.data.isDuplicate) {
                self.LoadingDialog = false;
                Swal.fire({
                  icon: "warning",
                  width: 500,
                  text: "Username : " + username + " ซ้ำกับในระบบ",
                });
              } else {
                self.LoadingDialog = false;
                Swal.fire({
                  icon: "success",
                  width: 500,
                  text: "Username : " + username + " สามารถใช้งานได้",
                });
              }
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

            Swal.fire({
              icon: "warning",
              width: 900,
              text: message,
            });
          });
      }
    },

    OpenRegisterDialog() {
      let self = this;
      self.ClearDataRegister();
      self.RegisterDialog = true;
    },

    ClearDataRegister() {
      let self = this;
      self.Username_Register = "";
      self.Password_Register = "";
      self.RePassword_Register = "";
      self.Firstname_Register = "";
      self.Lastname_Register = "";
      self.Telephone_Register = "";
      self.Email_Register = "";
    },

    CloseRegisterDialog() {
      let self = this;
      self.ClearDataRegister();
      self.RegisterDialog = false;
    },

    CheckLoginToken(value) {
      let self = this;
      let temp = {
        token: value,
      };
      axios
        .post(`${self.url}Login/CheckLoginToken`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.$router.push("/MainMenu");
          } else if (
            response.data.status == 1 &&
            response.data.message == "Token หมดอายุ"
          ) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: response.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error...",
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        self.flagPassword = false;
      } else {
        x.type = "password";
        self.flagPassword = true;
      }
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Mrs Eaves Small Caps OT";
  src: url("~@/assets/Font/SmallCaps.otf") format("opentype");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
.login-page,
.login-page >>> .v-card,
.login-page >>> button {
  font-family: "Mrs Eaves Small Caps OT", serif;
}
.login-page >>> input {
  font-family: "Mrs Eaves Lining OT", serif !important;
}
.login {
  width: 14rem;
}
.form {
  min-width: 50%;
}
.login-rounded-field >>> .v-input__slot {
  border-radius: 50px;
}
.login-rounded-field >>> input {
  padding-left: 20px;
  color: #231f20;
  opacity: 0.8;
}
.login-rounded-field >>> input::placeholder {
  color: #231f20;
  opacity: 0.8;
}
.password-eye-icon {
  position: relative;
  right: 15px;
  cursor: pointer;
}
.login-rounded-button,
.login-rounded-button >>> .v-btn__content {
  font-family: "Mrs Eaves Small Caps OT", serif !important;
  font-weight: normal;
  border-radius: 50px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3) !important;
}
.img-intersection {
  width: 100%;
  height: 100vh;
  max-width: 100%;
}
@media only screen and (max-width: 959px) {
  .logocss {
    display: none;
  }
  .rescss {
    margin: 1rem;
    width: 100% !important;
  }
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.image-container {
  width: 150px;
  height: 120px;
  text-align: center;
}
.image-container img {
  height: 100%;
}
.Header_Color {
  font-weight: bold;
}
</style>
